
const isHideFieldReport = (listHideFieldReport: EHideFieldReport[], field: EHideFieldReport) => {
    return listHideFieldReport.includes(field);
};

enum EHideFieldReport {
    PAYMENT_TYPE = 'PAYMENT_TYPE',
    COMMISSION = 'COMMISSION',
    PERCENT_COMMISSION = 'PERCENT_COMMISSION',
    TIP = 'TIP',
    SUPPLY_FEE = 'SUPPLY_FEE',
    TOTAL = 'TOTAL',
    TOTAL_SALE = 'TOTAL_SALE',
    DISCOUNT = 'DISCOUNT',
    TIP_COLLECTED = 'TIP_COLLECTED',
    TIP_FEE = 'TIP_FEE',
    TOTAL_TIP = 'TOTAL_TIP',
    CLEANING_FEE = 'CLEANING_FEE',
    PAYROLL = 'PAYROLL',
    PAYROLL_DETAIL = 'PAYROLL_DETAIL',
}

export { isHideFieldReport, EHideFieldReport };